import BalanceSheetAccountTypeStepTemplate
  from 'Views/Page/Content/Modal/Layouts/BalanceSheetAccountTypeStep/Layout/BalanceSheetAccountTypeStepTemplate';
import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import BalanceSheetAccountInfoTemplate from 'Views/Page/Content/Templates/balanceSheetAccountInfo/balanceSheetAccountInfoTemplate';

export const BalanceSheetAccountTypeLayout = () => {
  const { refreshPageContentCollection } = usePageContentContext();

  return (
    <BalanceSheetAccountTypeStepTemplate onRefresh={refreshPageContentCollection} infoLayoutComponent={BalanceSheetAccountInfoTemplate} useFD />
  );
};
